wo'c
<template>
  <div class="estimatedOutputReport" >
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">预估产出表</div>
        <div class="select-container">
          <div class="select-container-box">
            <span>日期</span>
            <el-date-picker size="small" :clearable="false" v-model="queryParams.StartDate" type="date"  
              placeholder="开始日期" value-format="yyyy-MM-dd" @change="changeTime(0)"
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box" style="padding:0 5px">
            <span>至</span>
          </div>
          <div class="select-container-box" style="padding:0 1px">
            <el-date-picker size="small" :clearable="false" v-model="queryParams.EndDate" type="date"  
              placeholder="结束日期" @change="changeTime(1)" value-format="yyyy-MM-dd" 
              :picker-options="pickerTimeOptions">
            </el-date-picker>
          </div>
          <div class="select-container-box">
            <span>基地</span>
            <el-select  filterable placeholder="请选择" size="small" v-model="queryParams.BaseId" @change="baseChange">
              <el-option v-for="(item, index) in baseList" :key="index" :label="item.value" :value="item.key" />
            </el-select>
          </div>
          <div class="select-container-box" >
            <span>塘口</span>
            <el-select  filterable placeholder="请选择" @change="pondChange" size="small" v-model="queryParams.PondId" >
              <el-option v-for="(item, index) in pondList" :key="index" :label="item.value" :value="item.key" />
            </el-select>
          </div>
          <div class="select-container-box">
            <span>品种</span>
            <el-select  filterable placeholder="请选择" size="small" v-model="queryParams.FishId" style="">
              <el-option v-for="(item, index) in fishList" :key="index" :label="item.categoryName" :value="item.categoryId" />
            </el-select>
          </div>
          <div class="select-container-box">
            <el-button size="small"  type="info" plain  class="query" @click="search(1)">查询</el-button>
          </div>
          </div>
        </div>
      <div class="table-container">
        <el-table :data="tableData" style="width: 100%" :span-method="objectSpanMethod" show-summary>
          <el-table-column label="区域">
            <el-table-column prop="pondName" label="塘号"></el-table-column>
          </el-table-column>
          <el-table-column label="白土">
            <el-table-column prop="pondArea" label="净面积(亩)"></el-table-column>
          </el-table-column>
          <el-table-column label="投放模式性成本" align="center">
            <el-table-column prop="fishName" label="品种"></el-table-column>
            <el-table-column prop="purchaseWeight" label="放养斤数(斤)"></el-table-column>
            <el-table-column prop="purchaseSpec" label="放养规格(斤/尾)"></el-table-column>
            <el-table-column prop="purchaseQuantity" label="放养尾数(尾)"></el-table-column>
            <el-table-column prop="purchaseDensity" label="放养密度(斤/亩)"></el-table-column>
            <el-table-column prop="purchaseAmount" label="放养金额(元)"></el-table-column>
            <el-table-column prop="fodderWeight" label="饲料用量(吨)"></el-table-column>
          </el-table-column>
          <el-table-column label="预估产出" align="center">
            <el-table-column prop="saleWeight" label="起捕重量(斤)"></el-table-column>
            <el-table-column prop="saleSpec" label="起捕规格(斤/尾)"></el-table-column>
            <el-table-column prop="saleQuantity" label="起捕尾数(尾)"></el-table-column>
            <el-table-column prop="survivingRate" label="成活率"></el-table-column>
            <el-table-column prop="salePrice" label="实际出鱼均价(元)"></el-table-column>
            <el-table-column prop="saleAmount" label="销售收入(元)"></el-table-column>
            <el-table-column prop="areaAvg" label="亩平(斤/亩)"></el-table-column>
            <el-table-column prop="materialRatio" label="料比(斤)"></el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>


<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../store";
import { MessageBox, Message } from "element-ui";
import { storage } from "../../service/storage";
import checkPermission from "../../service/checkPermission.js";
import {
  resolveFishBaseKeyFromList,
  fishBaseIdForQuery,
} from "@/common/resolveFishBaseSelection.js";
function findLastIndex(array, callback) {
  for (var i = array.length - 1; i >= 0; i--) {
    if (callback(array[i], i, array)) {
      return i;
    }
  }
  return -1;
}
export default {
  name: "estimatedOutputReport",
  data() {
    return {
      queryParams: {
        StartDate: '', // 开始时间
        EndDate: '', // 结束时间
        BaseId: '', // 基地Id
        PondId: '', // 塘口Id
        FishId: '', // 渔种Id
      },
      // 限制日期
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      baseList: [],
      pondList: [],
      fishList: [],
      tableData: [],
    };
  },
  mounted() {
    this.pageInit();
  },
  methods: {
    ...mapActions(modules.report, ["GetEstimatedProductionReport"]), // 查询
    ...mapActions(modules.base, ["getAllBaseList"]), // 基地
    ...mapActions(modules.pond, ["getFishPond"]), // 塘口
    ...mapActions(modules.fish, ["getFishReport"]), // 品种
    // 初始化
    async pageInit() {
      this.getTime()
      await this.getBaseList()
      this.search()
    },
    // 查询
    async search() {
      const params = {
        ...this.queryParams,
        BaseId: fishBaseIdForQuery(this.queryParams.BaseId, this.baseList),
      };
      const res = await this.GetEstimatedProductionReport(params)
      this.tableData = res
    },
    // 切换基地回调函数
    async baseChange (baseId) {
      const pondList = await this.getFishPond(baseId)
      this.pondList = [ { key: "", value: "全部" }, ...pondList ]
    },
    // 切换塘口回调函数
    pondChange () {
      this.queryParams.FishId = ''
      this.getFish()
    },
    // 品种
    async getFish () {
      const fishList = await this.getFishReport({
        baseId: this.queryParams.BaseId,
        pondId: this.queryParams.PondId
      })
      this.fishList = [ { categoryId: "", categoryName: "全部" }, ...fishList ]
    },
    async getBaseList () {
      this.baseList = await this.getAllBaseList(); //基地
      this.queryParams.BaseId = resolveFishBaseKeyFromList(
        this.baseList,
        storage.get("base")
      );
      if (this.queryParams.BaseId != null) {
        this.baseChange(this.queryParams.BaseId);
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let columnIndexList = [0, 1, 8, 16]
      if (columnIndexList.includes(columnIndex)) {
        if (rowIndex === 0 || row.pondName !== this.tableData[rowIndex - 1].pondName) {
          let rowspan = 1
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].pondName === row.pondName) {
              rowspan++
            } else {
              break
            }
          }
          return { rowspan, colspan: 1 }
        } else {
          return { rowspan: 0, colspan: 0 }
        }
      }
    },
    getSummaries(param){
      const { columns, data } = param;
      console.log(columns, data, '合计');
      return [ 1, 2]
    },
    // 获取选中时间
    getTime() {
      let startTime = storage.get("start");
      let endTime = storage.get("end");
      if (startTime) {
        this.queryParams.StartDate = startTime;
      } else {
        const start = new Date();
        start.setDate(1);
        start.setMonth(0);
        this.queryParams.StartDate = this.$timeformatDay(start);
      }
      if (endTime) {
        this.queryParams.EndDate = endTime;
      } else {
        this.queryParams.EndDate = this.$timeformatDay(new Date());
      }
    },
    // 存储选中时间
    changeTime(type) {
      if (type == 0) {
        storage.set("start", this.queryParams.StartDate);
      } else {
        storage.set("end", this.queryParams.EndDate);
      }
    },
  },
};
</script>
<style lang="stylus">
.estimatedOutputReport{
  .total{
    .el-select__tags{
      top:65%;
      height: 30px;
      overflow: auto;
    }
    .el-input__suffix{
      top:6px;
    }
    .is-focus .el-input__suffix {
      top:0px;
    }
    
  }
  .scroll-box1{
    width: 100%;
    // overflow: auto;
    // overflow-x:hidden;
  }
  .table-package {
    width: 100%;
    border-collapse: collapse;
    border:none;
  }
  .table-thead {
    border-top: 2px solid rgb(51, 137, 255);
    .ths,.thsss{
      width:50px!important;
    }
    >tr th {
      text-align: center;
      height: 36px;
      font-size: 14px;
      line-height: 36px;
      color: #666;
      font-weight: bold;
      border: 1px solid #e0e0e0;
      border-bottom:none;
      background-color: #f7f7f7;
    }
    >tr .ths {
      display: table-cell;
      border-bottom: 1px solid rgb(51, 137, 255);
      vertical-align: middle;
    }
    >tr .thss {
      border-bottom: 1px solid rgb(51, 137, 255);
    }
    .trs th {
      width:50px!important;
      border-bottom: 1px solid rgb(51, 137, 255);
    }
  }
  .table-tbodys {
    :hover{
      background:#c3e3ff;
      td:nth-child(1),td:nth-child(2),td:nth-child(3){
        background:#fff;
      }
    }
    tr {
      text-align: center;
      height: 37px;
      line-height: 37px;
      border: 1px solid #ddd;
      border:none;
      background-color: #fff;
    }
    td {
      width:50px!important;
      border: 1px solid #e0e0e0;
      border-top:none;
      color: #666;
      max-width: 96px;
      word-break: break-all;
      vertical-align:middle;
    }
  }
  .table-tfoot {
    tr>td {
      text-align: center;
      height: 37px;
      line-height: 37px;
      color: #333;
      font-size: 14px;
      width:90px!important;
      font-weight:bold;
      border: 1px solid #e0e0e0;
      border-top:none;
    }
    .row {
      // font-size: 14px;
      // background-color: #fff;
      // font-weight: bold;

      >td {
        // width:50px!important;
        // text-align: center;
        // border: 1px solid #e0e0e0;
        // color: #666;
        // font-weight:bold;
      }
    }
  }
  .hidden{
    display: none
  }
}

.estimatedOutputReport .table-package.fix {
  color: #666;
  position: fixed;
  z-index: 1000;
  top: 0px;
}
.estimatedOutputReport .el-table .el-table__row{
  background: #FFF !important;
}

.estimatedOutputReport .table-container .el-table .el-table__body tbody td {
  border-bottom: 1px solid #EBEEF5;
}
</style>
